import { Loader2 } from "lucide-react";

export function LoadingState({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-16 text-ink-muted">
      <Loader2 className="h-6 w-6 animate-spin text-teal-500" />
      <p className="text-sm">{label}</p>
    </div>
  );
}
